
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqoF1P51jXybd9Ts5ZD522jgv6Xg0bzqozuGrSVkJs_ZUMeta } from "/codebuild/output/src2079412061/src/src/pages/faq.vue?macro=true";
import { default as menu7rHFAPcHU5cCZqYQ5LyQ_45Tl3QgMZfQYYyrjBAphmZjcMeta } from "/codebuild/output/src2079412061/src/src/pages/menu.vue?macro=true";
import { default as index_gfqDk_Oxneu6YxNTaEKMiCXgRIdfyOhYzZDwNa699MMeta } from "/codebuild/output/src2079412061/src/src/pages/index.vue?macro=true";
import { default as contactkUwp65F_45pQlClXRqsM82OLNlMP0Q_45_8TNNTEv5y2_45CcMeta } from "/codebuild/output/src2079412061/src/src/pages/contact.vue?macro=true";
import { default as tutorialVizuv9YYMOTNy8iWpmDeu0I4K3YpHHulZknCCzt_45YgQMeta } from "/codebuild/output/src2079412061/src/src/pages/tutorial.vue?macro=true";
import { default as agreementzDEoF1e4A4f7I0HrMG2gOgeExTsF9hd3w_45j_45DHyZmc0Meta } from "/codebuild/output/src2079412061/src/src/pages/agreement.vue?macro=true";
import { default as about_45passt3nYZ_45VwlTx_yvMzznFe_HLJOMUK1WEuqr4UdC3soPEMeta } from "/codebuild/output/src2079412061/src/src/pages/about-pass.vue?macro=true";
import { default as index_ZNZODvAiZJKNXMj2cids1QBsHEb6FnNwahtyWkvc2QMeta } from "/codebuild/output/src2079412061/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93LVHYfSr0f1Y3NcwfUFS132efKLmVnrwrJz14GdKf8toMeta } from "/codebuild/output/src2079412061/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceD4xbZ7oPmQSw_XspZfXutmX2HsAlTTN9iyn5kgxJoEAMeta } from "/codebuild/output/src2079412061/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_937YQvbOsxJvJuAFJVOaiPl4RRxa6rNlUIM9ujMS6oD6YMeta } from "/codebuild/output/src2079412061/src/src/pages/notice/[id].vue?macro=true";
import { default as index_b54a0bc6MEQC0Olko0ETlZqz9243rsLcTK0NJBduhgMeta } from "/codebuild/output/src2079412061/src/src/pages/coupon/index.vue?macro=true";
import { default as indexFdWZ4Q9Ocj_45_45_auSgrJTeDBirKiK8l7w_455tgfPkeCUUMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/index.vue?macro=true";
import { default as indexUPHAdqPzR5EOL83ezNmzXVJmxWIG_45ykXQ_YtCuayftMMeta } from "/codebuild/output/src2079412061/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93XEGy3bltQg3223t66ou_454qd_45rPfnizR3AXvW0EHwYlUMeta } from "/codebuild/output/src2079412061/src/src/pages/parking/[id].vue?macro=true";
import { default as index932NnE1tr1LVMYCKl3NF2_45zZuD30MF9pKzP9HbtlnWIMeta } from "/codebuild/output/src2079412061/src/src/pages/history/index.vue?macro=true";
import { default as indexm2N9yTEldFqCnbDy7lkShlG1EEl6GPvNdxvNKw38EdwMeta } from "/codebuild/output/src2079412061/src/src/pages/monthly/index.vue?macro=true";
import { default as indexw5LD3C_X1Q4UxiiWciV5o0XQI0gsmQ9kc3JWq4lTc3sMeta } from "/codebuild/output/src2079412061/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexkdqjRlXtGxwxjfFseEFirehDIJ9ENmXn0_45upJsmOVVMMeta } from "/codebuild/output/src2079412061/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviARMA87mLauBsypfce9WlAvRTCny5tF1v_45TrnpAQB2x4Meta } from "/codebuild/output/src2079412061/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edity5q_452fqMrE_45CFJGUsyKIKz9MvIGPlWbjVJsP1H3vpusMeta } from "/codebuild/output/src2079412061/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement2QA400sH2X07v_45Ok6nsdbrl7Gl65srM_Qj6NitIxiZgMeta } from "/codebuild/output/src2079412061/src/src/pages/pass-agreement.vue?macro=true";
import { default as index05wMrGYqpsWLEqyYWgVc0aZ138VQgYv16w333BYV0tMMeta } from "/codebuild/output/src2079412061/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d6O5ClTirllwTca9eV1OUPMURxkL0WxPXZIAZFAEeNgsMeta } from "/codebuild/output/src2079412061/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm2gO_5i8rPk9Fr_tWBuE_anOcMHscomIWjRCdJWH5DkQMeta } from "/codebuild/output/src2079412061/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexA_459ryvNlTmpe_IpZkwQG3PTB40XnLCQzSQolaTAyihUMeta } from "/codebuild/output/src2079412061/src/src/pages/card/create/index.vue?macro=true";
import { default as indexYxusp_Q47QMdt6n7S3HItT16RWxYEz_45ed3_4559T9Be2IMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmxhPEWXH_45zdJ_H0U8pBzWvfLGj70NV2_45u8OMJroQm2kUMeta } from "/codebuild/output/src2079412061/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmolKIi0LfqyX_45Mrjc_45Bu0EKNAMQvX7nY8JKaKaEkTV7oMeta } from "/codebuild/output/src2079412061/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeq0X4wBn_BYAHetydCbfkdKR8YjI2QM6DTFQ5bknNkQUMeta } from "/codebuild/output/src2079412061/src/src/pages/membership/complete.vue?macro=true";
import { default as registerROQuUKB3h_d8HKD_REzqNWf_45LQ1rSiz5rF2wq7PsfQUMeta } from "/codebuild/output/src2079412061/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93wUFX1IQlpUqy2GTC77hWzVEJ76EELxA5Y7lDvnRl3x8Meta } from "/codebuild/output/src2079412061/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmHuy56hXkO_4540oF88zKqXXGGeYDrTDVOkiN8oEVYxxnMMeta } from "/codebuild/output/src2079412061/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93S6mWE7uq4h9tGxjkTTbhR_45HFjWMmhfVqP0mkCrU4QekMeta } from "/codebuild/output/src2079412061/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexFQc80iQ2EjBlSEGdmB422Z0YqFuK_45e_45OKQCbpFOBY78Meta } from "/codebuild/output/src2079412061/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeLnPBZcr7srdG2EMjzJVczjeBvMjm7LzzyS9ojPEpd9YMeta } from "/codebuild/output/src2079412061/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code4ickVuI9Fl4i8_45BgvkaKkAsVlr_45rk1sVDsQWxN_WDOsMeta } from "/codebuild/output/src2079412061/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completecrcjymUuO557SRM3FTV9uWTiOp2nS_45t4R04iDyhcz7QMeta } from "/codebuild/output/src2079412061/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registergnwnQH4_45ckurVDdc1g6Q8o96Kmvfy7qRDMDAi6YQzJYMeta } from "/codebuild/output/src2079412061/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeaxrnXBHUv7XdRxWmPvQoBLwpFLSQv8sJ_45Qqnbeoi4XQMeta } from "/codebuild/output/src2079412061/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexOHcHQsFagn9wumjJRbb2alijlzWdCBRiGRa9P3R_Uf0Meta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmn2O4yz8sz4LNE19whYoTF7WmHcWKBhAUMNLq7ZCfOn4Meta } from "/codebuild/output/src2079412061/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completejsmB6Cb8C49S2NOOLQxhSjJm27y_45BtpukCYal8ahywMMeta } from "/codebuild/output/src2079412061/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexZZLJ7RnzKu79IGzLV659jGBtCEH6cBK3WrObsqjpjfMMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93pCo92i7f4ANySWfLVwDfLbes33jY_45spLZ7Q7jgfv77AMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeNBp3pFpERvTAeOMC0RLot5WXXh9JQCqU_ZpodCNe_45CEMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasJaOmGsnb5nrT_tm_V8VIdWotiqeR_45kyw2hGOUU2jfDkMeta } from "/codebuild/output/src2079412061/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample4g_45p377hfv22B5Cns9fUzyvlWyi3v7wbV69jx68DUgYMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailIHtY47RZr3YOUcQOiqNgAvVkCLgBhcRMAwm46IHwRCMMeta } from "/codebuild/output/src2079412061/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmSCya_wkKPJ25NVZ47vxN_I9ZtA3fxDA2T1xHNXgc3GYMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent9dsVPBEtq9dtD74XEJBOO25Judq49HJhhfP_Cf9SxrEMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmilAB3eZlTaJlRgSZJn8c3_45W7d7i2uDK5DR0JU60LhaIMeta } from "/codebuild/output/src2079412061/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateVH3i13TuNbA6WYZK_JJLm6JxZavvmlyACDDSX49K_2MMeta } from "/codebuild/output/src2079412061/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete1Td0_45jfOUZocxaSvrNfl3vjKMsGSuyYFxoN8ve0llM0Meta } from "/codebuild/output/src2079412061/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code2O4G9wHRUo7g26iilWm65aw4rWVDjFDvJ9ttlCwjYj0Meta } from "/codebuild/output/src2079412061/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordtbHfWo_45WSkGXbWbFF4uXodrhD7JOhOiCFA_vR57SqiQMeta } from "/codebuild/output/src2079412061/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasHfCs1KGxy0Tw86rvSui5X1upAMqbSMGpJV73XauSs7wMeta } from "/codebuild/output/src2079412061/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerTVDW2RnfAkxekYG_jDUROpRxYoCnP52l_Bsri0ETk3oMeta } from "/codebuild/output/src2079412061/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codes6abG4QJqyl9Aq0aS4fboykZ_45Drbh79JV57sE8FnefUMeta } from "/codebuild/output/src2079412061/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indextRm_45_45DR9O_45xD2J5iCl0ldP_45W9H7CuxrA7tqkNMd7Er0Meta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexbCr8LqJOr_LA9CjXLbkk1UWNNjg_45d2OylbStJwA1odcMeta } from "/codebuild/output/src2079412061/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexFDCd1ZDGMPwgfhf9EpifDTodEFfq387UOvLNOFAraOQMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexgdBCTfS7Ny9VqSoFtYzI_hDzarqOZjfXhK_45Tmj_45RZE8Meta } from "/codebuild/output/src2079412061/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update_45zHTlwdz_45sll56Qe4lAlwooXus4yvWyP3lJ9XFWTBd4Meta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete0OhuJhhuzJi0QVbUjpMBlD3zXPhgs2SZn_450kiQSTmnoMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmF0cEYAxfv_45qYMCwRSVNg27dPuY7EOSF803Rv8LU4BuIMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexESZkVz1S8V0zIzcVJoJboqg8_452D0PsMmwqCxY8DpU_45QMeta } from "/codebuild/output/src2079412061/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completedK2SDI_45kDTrLCQKvMsztPOA82XyuCcN7bMABiDgNKfYMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatePwsl5Qrnpb2orrSeGakcO3q6RtufSXjG5fSOCEBb3CoMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexXDQGDHvGoXvBMK_45oQp4O4zupQtVxzKqzHD1xwH4Fjw4Meta } from "/codebuild/output/src2079412061/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexqu0zGbaac15u2eigir9WXqqnwKWLmY_45v_gnptAyZ9gYMeta } from "/codebuild/output/src2079412061/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeU5tIP5iAbpNN39x_r_iRg5pzIVRE_2RPeJBE07SvFVcMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index1kvbjCr9WLcwvP__NWp4NtRr0PyMhq_45ZING9NQOq_45BgMeta } from "/codebuild/output/src2079412061/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeZRkz2U79_450pqd9GvfSHKSL6oSex8Sbp2h2WoCPwQ7WgMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index6WoM0o9rgqOWOdJiJZDxX90vycenizswtmFfXryBpjoMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexU6r2jJKs6mTsCzUtcNJeilFwGWVG8iNzk9tBxQuBVpYMeta } from "/codebuild/output/src2079412061/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexIWQtLmmZsFBv_45UossMJt_45VpoxpM2Wy83l3KXxeBldC8Meta } from "/codebuild/output/src2079412061/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatePi3xsoIUKGYJlAxhsixrhF4qDVdlPvb32IjHfG588HwMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm_EwHMxXt0aEMP7fsg47E0dYHaGcNu0TJKlVCg00PJvYMeta } from "/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu7rHFAPcHU5cCZqYQ5LyQ_45Tl3QgMZfQYYyrjBAphmZjcMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index_gfqDk_Oxneu6YxNTaEKMiCXgRIdfyOhYzZDwNa699MMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index_b54a0bc6MEQC0Olko0ETlZqz9243rsLcTK0NJBduhgMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2079412061/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index932NnE1tr1LVMYCKl3NF2_45zZuD30MF9pKzP9HbtlnWIMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2079412061/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexw5LD3C_X1Q4UxiiWciV5o0XQI0gsmQ9kc3JWq4lTc3sMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexkdqjRlXtGxwxjfFseEFirehDIJ9ENmXn0_45upJsmOVVMMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexA_459ryvNlTmpe_IpZkwQG3PTB40XnLCQzSQolaTAyihUMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmxhPEWXH_45zdJ_H0U8pBzWvfLGj70NV2_45u8OMJroQm2kUMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmolKIi0LfqyX_45Mrjc_45Bu0EKNAMQvX7nY8JKaKaEkTV7oMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2079412061/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeq0X4wBn_BYAHetydCbfkdKR8YjI2QM6DTFQ5bknNkQUMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerROQuUKB3h_d8HKD_REzqNWf_45LQ1rSiz5rF2wq7PsfQUMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmHuy56hXkO_4540oF88zKqXXGGeYDrTDVOkiN8oEVYxxnMMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeLnPBZcr7srdG2EMjzJVczjeBvMjm7LzzyS9ojPEpd9YMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code4ickVuI9Fl4i8_45BgvkaKkAsVlr_45rk1sVDsQWxN_WDOsMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completecrcjymUuO557SRM3FTV9uWTiOp2nS_45t4R04iDyhcz7QMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registergnwnQH4_45ckurVDdc1g6Q8o96Kmvfy7qRDMDAi6YQzJYMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmn2O4yz8sz4LNE19whYoTF7WmHcWKBhAUMNLq7ZCfOn4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completejsmB6Cb8C49S2NOOLQxhSjJm27y_45BtpukCYal8ahywMMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexZZLJ7RnzKu79IGzLV659jGBtCEH6cBK3WrObsqjpjfMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeNBp3pFpERvTAeOMC0RLot5WXXh9JQCqU_ZpodCNe_45CEMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample4g_45p377hfv22B5Cns9fUzyvlWyi3v7wbV69jx68DUgYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailIHtY47RZr3YOUcQOiqNgAvVkCLgBhcRMAwm46IHwRCMMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmSCya_wkKPJ25NVZ47vxN_I9ZtA3fxDA2T1xHNXgc3GYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent9dsVPBEtq9dtD74XEJBOO25Judq49HJhhfP_Cf9SxrEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmilAB3eZlTaJlRgSZJn8c3_45W7d7i2uDK5DR0JU60LhaIMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete1Td0_45jfOUZocxaSvrNfl3vjKMsGSuyYFxoN8ve0llM0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code2O4G9wHRUo7g26iilWm65aw4rWVDjFDvJ9ttlCwjYj0Meta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordtbHfWo_45WSkGXbWbFF4uXodrhD7JOhOiCFA_vR57SqiQMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerTVDW2RnfAkxekYG_jDUROpRxYoCnP52l_Bsri0ETk3oMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codes6abG4QJqyl9Aq0aS4fboykZ_45Drbh79JV57sE8FnefUMeta || {},
    component: () => import("/codebuild/output/src2079412061/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2079412061/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]